import { EditIntegrationWebController } from '../controller/EditIntegrationWebController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { EditIntegrationFormContext } from '../types/EditIntegrationFormContext';
import { IntegrationData } from '../../types/integration-data';
import { IntegrationType } from '../../types/integration-type';

export class EditIntegrationWebComponent extends BaseWebComponentElement {
  public controller!: EditIntegrationWebController;
  private integrationType: IntegrationType;
  private integrationId: string | null;
  private sensors: Array<object> | null;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: EditIntegrationWebController,
    });
  }

  public get formContext(): EditIntegrationFormContext {
    const context = this.getAttribute('context');

    if (!EditIntegrationFormContext.isValid(context)) {
      throw new Error(`EditIntegrationForm context not valid: ${context}`);
    }

    return context as EditIntegrationFormContext;
  }

  public setIntegrationType(integrationType: IntegrationType) {
    this.integrationType = integrationType;
    this.controller.adaptViewBasedOnType(integrationType);
  }

  public getIntegrationType(): IntegrationType {
    return this.integrationType;
  }

  public setIntegrationId(id: string) {
    this.integrationId = id;
  }

  public getIntegrationId(): string | null {
    return this.integrationId;
  }

  public setSensors(sensors: Array<object>) {
    this.sensors = sensors;
  }

  public getSensors(): Array<object> | null {
    return this.sensors;
  }

  public get getValue(): Promise<IntegrationData> {
    return this.controller.getValue();
  }

  public async initForm() {
    this.sensors = null;
    this.integrationId = null;
    this.controller.view.initForm();
  }

  public setIntegrationViewData(integration) {
    this.controller.view.setIntegrationViewData(integration);
  }

  public hasChangedData(): boolean {
    return this.controller.hasChangedData();
  }

  public async setupEditIntegration(integration) {
    await this.initForm().catch(console.error);
    this.setIntegrationId(integration._id);
    this.setSensors(this.controller.getSensorsByType(integration.sensors));
    this.setIntegrationType(integration.type);
    this.setIntegrationViewData(integration);
  }
}
